module.exports = __webpack_public_path__ + "img/instacash-logo-white.925e427f.svg";